export default "__VITE_ASSET__ccb7bc7e__"